var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-9a9e05ea-81ce-4e22-b252-7641a30573c0 {\n        fill: #4d4d4d;\n      }\n\n      .uuid-dc1437be-3ef8-4e44-bd01-280a894d0f0b {\n        fill: #f2f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-7a769110-d597-43ef-bade-658def4c8eb2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-dc1437be-3ef8-4e44-bd01-280a894d0f0b",
    d: "M16,21.32c-3.82,0-6.71-4.71-6.83-4.91-.19-.32-.19-.72,0-1.03.12-.2,3.01-4.91,6.83-4.91s6.71,4.71,6.83,4.91c.19.32.19.72,0,1.03-.12.2-3.01,4.91-6.83,4.91ZM11.23,15.89c.91,1.29,2.84,3.43,4.77,3.43s3.86-2.15,4.77-3.43c-.91-1.29-2.84-3.43-4.77-3.43s-3.86,2.15-4.77,3.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-dc1437be-3ef8-4e44-bd01-280a894d0f0b",
    cx: 16,
    cy: 15.89,
    r: 2.13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/Visible.8e110fad685814946ec35a487c341f15.svg";
export { ForwardRef as ReactComponent };